// Mock data for Pringle Construction LLC

export const heroData = {
  title: "Building Excellence, Crafting Legacies",
  subtitle: "Premier Residential & Commercial Construction",
  description: "Pringle Construction LLC delivers world-class construction solutions with unmatched precision and craftsmanship.",
  ctaText: "Start Your Project",
  ctaSecondary: "View Portfolio",
  heroImage: "https://images.unsplash.com/photo-1768223933860-6d62bc5b2ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3NzA4Njk2MDN8MA&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: 1,
    title: "Residential Construction",
    description: "Custom homes, renovations, and luxury residential projects built to perfection with attention to every detail.",
    icon: "Home",
    features: ["Custom Home Building", "Luxury Renovations", "Home Extensions", "Interior Remodeling"]
  },
  {
    id: 2,
    title: "Commercial Construction",
    description: "State-of-the-art commercial buildings designed for functionality, aesthetics, and long-term value.",
    icon: "Building2",
    features: ["Office Buildings", "Retail Spaces", "Mixed-Use Developments", "Tenant Improvements"]
  },
  {
    id: 3,
    title: "Project Management",
    description: "Comprehensive project oversight ensuring timely delivery, budget control, and exceptional quality standards.",
    icon: "ClipboardList",
    features: ["Timeline Management", "Budget Optimization", "Quality Control", "Regulatory Compliance"]
  },
  {
    id: 4,
    title: "Design & Consultation",
    description: "Expert architectural consultation and design services to bring your vision to life with innovative solutions.",
    icon: "Ruler",
    features: ["Architectural Design", "3D Visualization", "Site Analysis", "Feasibility Studies"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Modern Luxury Residence",
    category: "Residential",
    location: "Beverly Hills, CA",
    description: "Contemporary 8,500 sq ft masterpiece featuring smart home integration and sustainable design.",
    image: "https://images.unsplash.com/photo-1758448756880-01dbaf85597d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNpZGVudGlhbHxlbnwwfHx8fDE3NzA4Njk2Mzh8MA&ixlib=rb-4.1.0&q=85",
    value: "$12.5M",
    year: "2024"
  },
  {
    id: 2,
    title: "Premium Office Tower",
    category: "Commercial",
    location: "Downtown District",
    description: "15-story Class A office building with cutting-edge amenities and LEED Gold certification.",
    image: "https://images.unsplash.com/photo-1672152567751-71ea0298e821?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MDg2OTY0N3ww&ixlib=rb-4.1.0&q=85",
    value: "$45M",
    year: "2024"
  },
  {
    id: 3,
    title: "Waterfront Estate",
    category: "Residential",
    location: "Malibu, CA",
    description: "Stunning coastal property with panoramic ocean views and infinity pool.",
    image: "https://images.unsplash.com/photo-1762195804027-04a19d9d3ab6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNpZGVudGlhbHxlbnwwfHx8fDE3NzA4Njk2Mzh8MA&ixlib=rb-4.1.0&q=85",
    value: "$18M",
    year: "2023"
  },
  {
    id: 4,
    title: "Corporate Headquarters",
    category: "Commercial",
    location: "Tech Park",
    description: "State-of-the-art tech campus with collaborative workspaces and green building standards.",
    image: "https://images.unsplash.com/photo-1601785491008-d1153dfadd57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MDg2OTY0N3ww&ixlib=rb-4.1.0&q=85",
    value: "$32M",
    year: "2023"
  },
  {
    id: 5,
    title: "Luxury High-Rise",
    category: "Residential",
    location: "Manhattan",
    description: "35-story residential tower with premium finishes and world-class amenities.",
    image: "https://images.unsplash.com/photo-1623912253007-df82ef63169f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZXNpZGVudGlhbHxlbnwwfHx8fDE3NzA4Njk2Mzh8MA&ixlib=rb-4.1.0&q=85",
    value: "$85M",
    year: "2023"
  },
  {
    id: 6,
    title: "Mixed-Use Development",
    category: "Commercial",
    location: "Urban Center",
    description: "Innovative mixed-use complex combining retail, residential, and office spaces.",
    image: "https://images.unsplash.com/photo-1554924663-bebd5e902d70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MDg2OTY0N3ww&ixlib=rb-4.1.0&q=85",
    value: "$58M",
    year: "2022"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Richardson",
    role: "CEO, Richardson Enterprises",
    content: "Pringle Construction transformed our vision into reality. Their attention to detail and commitment to excellence is unmatched. Our new headquarters exceeded all expectations.",
    rating: 5,
    image: "MR"
  },
  {
    id: 2,
    name: "Sarah Thompson",
    role: "Homeowner",
    content: "Working with Pringle Construction on our dream home was an absolute pleasure. They guided us through every step and delivered beyond our wildest dreams.",
    rating: 5,
    image: "ST"
  },
  {
    id: 3,
    name: "David Chen",
    role: "Property Developer",
    content: "We've partnered with Pringle Construction on multiple projects. Their professionalism, quality craftsmanship, and on-time delivery make them our go-to construction partner.",
    rating: 5,
    image: "DC"
  }
];

export const stats = [
  {
    id: 1,
    value: "500+",
    label: "Projects Completed",
    icon: "Building"
  },
  {
    id: 2,
    value: "25+",
    label: "Years Experience",
    icon: "Award"
  },
  {
    id: 3,
    value: "98%",
    label: "Client Satisfaction",
    icon: "ThumbsUp"
  },
  {
    id: 4,
    value: "$2B+",
    label: "Projects Value",
    icon: "TrendingUp"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Elite Craftsmanship",
    description: "Every project is executed with precision and attention to detail that defines luxury construction.",
    icon: "Gem"
  },
  {
    id: 2,
    title: "Proven Track Record",
    description: "Over 25 years of delivering exceptional results on time and within budget.",
    icon: "Target"
  },
  {
    id: 3,
    title: "Innovation Driven",
    description: "Leveraging cutting-edge technology and sustainable practices in every build.",
    icon: "Lightbulb"
  },
  {
    id: 4,
    title: "Client-Centric",
    description: "Your vision is our mission. We collaborate closely to bring your dreams to life.",
    icon: "Heart"
  }
];

export const contactInfo = {
  email: "james@pringleconstructionllc.com",
  phone: "+1 (555) 123-4567",
  address: "123 Construction Plaza, Suite 500",
  city: "Los Angeles, CA 90012",
  hours: "Monday - Friday: 8:00 AM - 6:00 PM"
};
